var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { castDateToISO } from "@bookingcom/bui-core/utilities/date";
export var Context = React.createContext({});
var CalendarProvider = function (props) {
    var children = props.children, calendarProps = __rest(props, ["children"]);
    var startDate = calendarProps.startDate, endDate = calendarProps.endDate;
    var _a = React.useState(null), hoveredDateISO = _a[0], setHoveredDateISO = _a[1];
    return (React.createElement(Context.Provider, { value: __assign(__assign({}, calendarProps), { hoveredDateISO: hoveredDateISO, setHoveredDateISO: setHoveredDateISO, startDateISO: startDate && castDateToISO(startDate), endDateISO: (endDate && castDateToISO(endDate)) || null }) }, children));
};
export default CalendarProvider;
